import axios from "axios";
import { API_BASE_URL } from "../environment";

export const createNewVisitor = async (data) => {
  const res = await axios.post(`${API_BASE_URL}/common?table=visitors`, data);
  return res.data;
};
export const getAllVisitor = async (data) => {
  const { id, type } = JSON.parse(sessionStorage.getItem("info"));
  const res = await axios.get(
    `${API_BASE_URL}/visitors?user_id=${id}&user_type=${type}&start_date=${data.start_date}&end_date=${data.end_date}&one_time=${data.one_time}&regular_visit=${data.regular_visit}&page_name=${data.page_name}&id=${data.id}`,
    data
  );
  return res.data;
};

export const updateVisitorsById = async (id, data) => {
  const res = await axios.patch(
    `${API_BASE_URL}/common?table=visitors&id=${id}`,
    data
  );
  return res.data;
};
